import React, { createContext, useContext } from "react";

const CruiseContext = createContext(null);

export const useCruise = () => useContext(CruiseContext);

export const CruiseProvider = ({ cruise, children }) => (
  <div style={{ "--hh-gold": cruise.themeGold }}>
    <CruiseContext.Provider value={cruise}>{children}</CruiseContext.Provider>
  </div>
);

export default CruiseContext;
